"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
;
var Pagination = /** @class */ (function () {
    function Pagination(data) {
        this.currentPage = data['x-pagination-current-page'];
        this.perPage = data['x-pagination-per-page'];
        this.pageCount = data['x-pagination-page-count'];
        this.totalCount = data['x-pagination-total-count'];
    }
    return Pagination;
}());
exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map